<template>
  <div>
    <h2>Not found page</h2>
  </div>
</template>

<script>
export default {
  name: "page404"
}
</script>

<style scoped>

</style>
